import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Index403.scss';

export const Index403: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/home');
  };

  return (
    <div className="error-page">
      <div className="error-content">
        <div className="error-number">403</div>
        <div className="error-title">访问被拒绝</div>
        <div className="error-description">
          抱歉，您没有权限访问此页面。请联系管理员获取相应权限。
        </div>
        <div className="error-actions">
          <button className="back-btn" onClick={handleGoBack}>
            <i className="fas fa-arrow-left"></i>
            返回
          </button>
          <button className="home-btn" onClick={handleGoHome}>
            <i className="fas fa-home"></i>
            首页
          </button>
        </div>
      </div>
    </div>
  );
};
